import { VIEW_CHECKBOX } from "../action/Action";

const initialState = [{
    viewCheckbox: false,
    id: ''
}]

const checkboxReducer = (state = initialState, action) => {
    switch (action?.type) {
        case VIEW_CHECKBOX:
            return {
                ...state,
                viewCheckbox: action?.payload,
                id: action?.payload
            };
        default: return state;
    }

}

export default checkboxReducer;